import { TestType } from "@/queries/types";
import { t } from "@lingui/core/macro";

export function getTestType(type: TestType) {
  switch (type) {
    case "quiz":
      return t`Skills Test`;
    case "video":
      return t`Async Interview`;
    case "homework":
      return t`Homework`;
    default:
      return "";
  }
}
